import {
  Card,
  CardContent,
  Grid,
  MenuItem,
  TextField,
  Tab,
  Tabs,
  IconButton,
  Box,
  Container,
  Dialog,
  DialogTitle,
  Divider,
  Checkbox,
  FormControlLabel
} from '@mui/material'
import { Formik } from 'formik'
import React, { useState } from 'react'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'
import { FavoriteSection } from '../../../components/FavoriteComponents'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

function CreateItemDialog({
  visible,
  onSubmit,
  onClose,
  initialValue,
  title,
  okText,
  kitchenCounterData,
  outlet,
  unitsData,
  mode
}) {


  const [value, setValue] = useState(0)
  const [qtyDisabled, setQtyDisabled] = useState(true)

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  if (outlet === null || outlet === undefined)
    outlet = ""

  if (initialValue == undefined)
    initialValue = {
      name: '',
      sku: '',
      image_path: '',
      stock: 0,
      maintain_inventory: false,
      kitchen_counter_id: '',
      itemlist: [],
      delete_status: false,
      parcel_amt: 0,
      unit: mode === 'new' ? unitsData[0]?.name : '',
      weighing_scale_code: 0,
      is_favorite: false,
      priority: 0,
      commission: 0,
      price: [
        {
          unit_price: 0,
          igst: 0,
          cgst: 0,
          sgst: 0,
          cess1: 0,
          cess2: 0,
          cost_price: 0,
          discount_percentage: 0,
          discount_value: 0,
          price_id: 1,
        },
        {
          unit_price: 0,
          igst: 0,
          cgst: 0,
          sgst: 0,
          cess1: 0,
          cess2: 0,
          cost_price: 0,
          discount_percentage: 0,
          discount_value: 0,
          price_id: 2,
        },
        {
          unit_price: 0,
          igst: 0,
          cgst: 0,
          sgst: 0,
          cess1: 0,
          cess2: 0,
          cost_price: 0,
          discount_percentage: 0,
          discount_value: 0,
          price_id: 3,
        },
      ],
    }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Required').min(1, 'Min length is 1 character'),
    kitchen_counter_id: Yup.string().required('Required'),
    weighing_scale_code: Yup.number().integer('Only values 0 or 1 are allowed.').min(0, 'Only values 0 or 1 are allowed.').max(1, 'Only values 0 or 1 are allowed.'),
    commission: Yup.number()
      .typeError('Invalid Number')
      .min(0, 'Percentage must be between 0 and 100')
      .max(100, 'Percentage must be between 0 and 100'),
    itemlist: Yup.array().of(
      Yup.object().shape({
        _id: Yup.string().required('Required'),
      })
    ),
  })

  const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
    const payload = {
      ...values,
      commission: values.commission === "" || values.commission === null || values.commission === undefined
        ? 0
        : Number(values.commission),
    }
    onSubmit(payload)
  }

  const onDialogClose = () => {
    setValue(0)
    setQtyDisabled(true)
    onClose()
  }

  return (
    <div>
      <Dialog maxWidth={'sm'} fullWidth anchor="right" backdrop="static" variant="temporary" open={visible}>
        <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
          {title}
          <IconButton
            component="span"
            size='small'
            sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
            onClick={onDialogClose}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Container sx={{ marginBottom: 5 }} >
          <Formik
            initialValues={initialValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              status,
              setFieldValue
            }) => (

              <form onSubmit={handleSubmit}>
                <Divider my={2} />
                <Card >
                  <CardContent>
                    <Grid container spacing={5} style={{ paddingTop: 10 }}>
                      <Grid item md>
                        <TextField
                          size='small'
                          name="name"
                          label="Name"
                          value={values.name}
                          margin="dense"
                          error={Boolean(touched.name && errors.name)}
                          fullWidth
                          helperText={touched.name && errors.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={5} style={{ paddingTop: 15 }}>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          name="sku"
                          label="SKU"
                          margin="dense"
                          value={values.sku}
                          error={Boolean(touched.sku && errors.sku)}
                          fullWidth
                          helperText={touched.sku && errors.sku}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          name="image_path"
                          label="Image Name"
                          margin="dense"
                          value={values.image_path}
                          error={Boolean(touched.image_path && errors.image_path)}
                          fullWidth
                          helperText={touched.image_path && errors.image_path}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={5} style={{ paddingTop: 15 }}>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          name="outlet"
                          label="Outlet"
                          margin="dense"
                          value={outlet}
                          error={Boolean(touched.outlet && errors.outlet)}
                          fullWidth
                          helperText={touched.outlet && errors.outlet}
                          onBlur={handleBlur}

                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          label="Kitchen Counter"
                          id="kitchen_counter_select"
                          name="kitchen_counter_id"
                          margin="dense"
                          value={values.kitchen_counter_id}
                          fullWidth
                          error={Boolean(
                            touched.kitchen_counter_id && errors.kitchen_counter_id
                          )}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                          select
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {kitchenCounterData && kitchenCounterData.map((counter, i) => (
                            <MenuItem dense key={i} value={counter._id}>
                              {counter.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                    </Grid>
                    <Grid container spacing={5} style={{ paddingTop: 15 }}>
                      <Grid item md>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size='small'
                              name='maintain_inventory'
                              checked={values.maintain_inventory}
                              onChange={(e, value) => {
                                if (e.target.checked) {
                                  setQtyDisabled(false)

                                } else {
                                  setQtyDisabled(true)
                                }
                                setFieldValue('maintain_inventory', e.target.checked)
                              }}
                              onBlur={handleBlur}
                              color="primary"
                            />
                          }
                          label="Maintain Inventory"
                        />
                      </Grid>
                      {mode == 'new' && <Grid item md>
                        <TextField
                          size='small'
                          label='Stock Quantity'
                          id="stock"
                          name="stock"
                          margin="dense"
                          type='number'
                          value={values.stock}
                          fullWidth
                          error={Boolean(
                            touched.stock && errors.stock
                          )}
                          disabled={qtyDisabled}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                        />
                      </Grid>}
                    </Grid>

                    <Divider sx={{ marginTop: 3, marginBottom: 2 }} />

                    <Grid container spacing={5} style={{ paddingTop: 10 }}>
                      <Grid item xs={12}>
                        <FavoriteSection
                          isFavorite={values.is_favorite || false}
                          priority={values.priority || 0}
                          onFavoriteChange={(checked) => {
                            setFieldValue('is_favorite', checked)
                            if (!checked) {
                              setFieldValue('priority', 0)
                            }
                          }}
                          onPriorityChange={(priority) => {
                            setFieldValue('priority', priority)
                          }}
                          favoriteLabel="Mark as Favorite"
                          priorityLabel="Priority Level"
                        />
                      </Grid>
                    </Grid>

                    <Grid container columns={15} spacing={5} style={{ paddingTop: 15 }}>
                      <Grid item md>
                        <TextField
                          size='small'
                          label="Unit"
                          id="unit_select"
                          name="unit"
                          margin="dense"
                          value={values.unit}
                          fullWidth
                          error={Boolean(
                            touched.unit && errors.unit
                          )}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                          select
                        >
                          {unitsData && unitsData.map((unit) => (
                            <MenuItem key={unit._id} value={unit.name}>
                              {unit.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item md>
                        <TextField
                          size='small'
                          name="price[0].cost_price"
                          label="Cost Price"
                          margin="dense"
                          value={values.price[0].cost_price}
                          error={Boolean(touched.cost_price && errors.cost_price)}
                          fullWidth
                          helperText={touched.cost_price && errors.cost_price}
                          onBlur={handleBlur}
                          type="number"
                          onChange={(e, value) => {
                            if (e.target.value.trim() != "") {
                              if (e.target.value < 0) {
                                setFieldValue("price[0].cost_price", 0);
                              }
                              else {
                                setFieldValue("price[0].cost_price", +e.target.value.trim());
                              }
                            }
                            else
                              setFieldValue("price[0].cost_price", e.target.value.trim());
                          }}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item md>
                        <TextField
                          size='small'
                          name="weighing_scale_code"
                          label="Weighing Scale Code"
                          margin="dense"
                          value={values.weighing_scale_code}
                          error={Boolean(touched.weighing_scale_code && errors.weighing_scale_code)}
                          fullWidth
                          helperText={touched.weighing_scale_code && errors.weighing_scale_code}
                          onBlur={handleBlur}
                          type="number"
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={5} style={{ paddingTop: 15 }}>
                      <Grid item md={4}>
                        <TextField
                          size='small'
                          name="price[0].cess1"
                          label="CESS1 %"
                          margin="dense"
                          value={values.price[0].cess1}
                          error={Boolean(touched.cess1 && errors.cess1)}
                          fullWidth
                          helperText={touched.cess1 && errors.cess1}
                          onBlur={handleBlur}
                          type="number"
                          onChange={(e, value) => {
                            if (e.target.value.trim() != "") {
                              if (e.target.value < 0) {
                                setFieldValue("price[0].cess1", 0);
                              }
                              else {
                                setFieldValue("price[0].cess1", +e.target.value.trim());
                              }
                            }
                            else
                              setFieldValue("price[0].cess1", e.target.value.trim());

                          }}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={4}>
                        <TextField
                          size='small'
                          name="price[0].cess2"
                          label="CESS2 %"
                          margin="dense"
                          value={values.price[0].cess2}
                          error={Boolean(touched.cess2 && errors.cess2)}
                          fullWidth
                          helperText={touched.cess2 && errors.cess2}
                          onBlur={handleBlur}
                          type="number"
                          onChange={(e, value) => {
                            if (e.target.value.trim() != "") {
                              if (e.target.value < 0) {
                                setFieldValue("price[0].cess2", 0);
                              }
                              else {
                                setFieldValue("price[0].cess2", +e.target.value.trim());
                              }
                            }
                            else
                              setFieldValue("price[0].cess2", e.target.value.trim());

                          }}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <TextField
                          size='small'
                          name="parcel_amt"
                          label="Parcel Amount"
                          margin="dense"
                          value={values.parcel_amt}
                          error={Boolean(touched.parcel_amt && errors.parcel_amt)}
                          fullWidth
                          helperText={touched.parcel_amt && errors.parcel_amt}
                          onBlur={handleBlur}
                          type="number"
                          onChange={(e, value) => {
                            if (e.target.value.trim() != "") {
                              if (e.target.value < 0) {
                                setFieldValue("parcel_amt", 0);
                              }
                              else {
                                setFieldValue("parcel_amt", +e.target.value.trim());
                              }
                            }
                            else {
                              setFieldValue("parcel_amt", e.target.value.trim());
                            }
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={5} style={{ paddingTop: 15 }}>
                      <Grid item md={4}>
                        <TextField
                          size='small'
                          name="commission"
                          label="Commission (%)"
                          margin="dense"
                          value={values.commission ?? 0}
                          error={Boolean(touched.commission && errors.commission)}
                          fullWidth
                          helperText={touched.commission && errors.commission}
                          onBlur={handleBlur}
                          type="text"
                          inputProps={{ inputMode: "decimal", maxLength: 6 }}
                          onChange={(e) => {
                            const v = e.target.value;
                            if (v === "") {
                              setFieldValue("commission", "");
                              return;
                            }
                            // Live filter: digits, at most one dot, max 2 decimals, range 0-100
                            if (!/^\d*\.?\d{0,2}$/.test(v)) return;
                            if (Number(v) > 100) return;
                            setFieldValue("commission", v);
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    <Divider sx={{ paddingTop: 3 }} />
                    <div>
                      <Tabs value={value} onChange={handleTabChange}>
                        <Tab label="PRICE1" {...a11yProps(0)} />
                        <Tab label="PRICE2" {...a11yProps(1)} />
                        <Tab label="PRICE3" {...a11yProps(2)} />
                      </Tabs>

                      <TabPanel value={value} index={0}>
                        <Grid container spacing={5}>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[0].unit_price"
                              label="Unit Price"
                              margin="dense"
                              value={values.price[0].unit_price}
                              error={Boolean(touched.unit_price && errors.unit_price)}
                              fullWidth
                              helperText={touched.unit_price && errors.unit_price}
                              onBlur={handleBlur}
                              type="number"
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {

                                  if (e.target.value < 0) {
                                    setFieldValue("price[0].unit_price", 0);
                                  }
                                  else {
                                    setFieldValue("price[0].unit_price", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[0].unit_price", e.target.value.trim());
                                }

                              }}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[0].cgst"
                              label="CGST %"
                              margin="dense"
                              value={values.price[0].cgst}
                              error={Boolean(touched.cgst && errors.cgst)}
                              fullWidth
                              helperText={touched.cgst && errors.cgst}
                              onBlur={handleBlur}
                              type="number"
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {

                                  if (e.target.value < 0) {
                                    setFieldValue("price[0].cgst", 0);
                                  }
                                  else {
                                    setFieldValue("price[0].cgst", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[0].cgst", e.target.value.trim());
                                }

                              }}
                              variant="outlined"

                            />
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[0].sgst"
                              label="SGST %"
                              margin="dense"
                              value={values.price[0].sgst}
                              error={Boolean(touched.sgst && errors.sgst)}
                              fullWidth
                              helperText={touched.sgst && errors.sgst}
                              onBlur={handleBlur}
                              type="number"
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {

                                  if (e.target.value < 0) {
                                    setFieldValue("price[0].sgst", 0);
                                  }
                                  else {
                                    setFieldValue("price[0].sgst", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[0].sgst", e.target.value.trim());
                                }

                              }}
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>
                      </TabPanel>

                      <TabPanel value={value} index={1}>
                        <Grid container spacing={5}>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[1].unit_price"
                              label="Unit Price"
                              margin="dense"
                              value={values.price[1].unit_price}
                              error={Boolean(touched.unit_price && errors.unit_price)}
                              fullWidth
                              helperText={touched.unit_price && errors.unit_price}
                              onBlur={handleBlur}
                              type="number"
                              onChange={handleChange}
                              variant="outlined"

                            />
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[1].cgst"
                              label="CGST %"
                              margin="dense"
                              value={values.price[1].cgst}
                              error={Boolean(touched.cgst && errors.cgst)}
                              fullWidth
                              helperText={touched.cgst && errors.cgst}
                              onBlur={handleBlur}
                              type="number"
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {
                                  if (e.target.value < 0) {
                                    setFieldValue("price[1].cgst", 0);
                                  }
                                  else {
                                    setFieldValue("price[1].cgst", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[1].cgst", e.target.value.trim());
                                }

                              }}
                              variant="outlined"

                            />
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[1].sgst"
                              label="SGST %"
                              margin="dense"
                              value={values.price[1].sgst}
                              error={Boolean(touched.sgst && errors.sgst)}
                              fullWidth
                              helperText={touched.sgst && errors.sgst}
                              onBlur={handleBlur}
                              type="number"
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {

                                  if (e.target.value < 0) {
                                    setFieldValue("price[1].sgst", 0);
                                  }
                                  else {
                                    setFieldValue("price[1].sgst", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[1].sgst", e.target.value.trim());
                                }

                              }}
                              variant="outlined"

                            />
                          </Grid>
                        </Grid>
                      </TabPanel>
                      <TabPanel value={value} index={2}>
                        <Grid container spacing={5}>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[2].unit_price"
                              label="Unit Price"
                              margin="dense"
                              value={values.price[2].unit_price}
                              error={Boolean(touched.unit_price && errors.unit_price)}
                              fullWidth
                              helperText={touched.unit_price && errors.unit_price}
                              onBlur={handleBlur}
                              type="number"
                              onChange={handleChange}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[2].cgst"
                              label="CGST %"
                              margin="dense"
                              value={values.price[2].cgst}
                              error={Boolean(touched.cgst && errors.cgst)}
                              fullWidth
                              helperText={touched.cgst && errors.cgst}
                              onBlur={handleBlur}
                              type="number"
                              defaultValue={0}
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {

                                  if (e.target.value < 0) {
                                    setFieldValue("price[2].cgst", 0);
                                  }
                                  else {
                                    setFieldValue("price[2].cgst", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[2].cgst", e.target.value.trim());
                                }

                              }}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={3}>
                            <TextField
                              size='small'
                              name="price[2].sgst"
                              label="SGST %"
                              margin="dense"
                              value={values.price[2].sgst}
                              error={Boolean(touched.sgst && errors.sgst)}
                              fullWidth
                              helperText={touched.sgst && errors.sgst}
                              onBlur={handleBlur}
                              type="number"
                              onChange={(e, value) => {
                                if (e.target.value.trim() != "") {

                                  if (e.target.value < 0) {
                                    setFieldValue("price[2].sgst", 0);
                                  }
                                  else {
                                    setFieldValue("price[2].sgst", +e.target.value.trim());
                                  }
                                }
                                else {
                                  setFieldValue("price[2].sgst", e.target.value.trim());
                                }

                              }}
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </div>
                  </CardContent>
                </Card>
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                      {okText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Dialog>
    </div>
  )
}

export default CreateItemDialog
